export default __webpack_public_path__ + "static/media/mercado-e-seu-02.e86db4f8.png";